import { Injectable } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StorageProvider {
    constructor(private storageMap: StorageMap) {}

    public get(item: string): Observable<any> {
        return this.storageMap.get(item).pipe(catchError((err) => of(err)));
    }

    /** Set data from local storage */
    public set(item: string, data: unknown): Observable<boolean> {
        return this.storageMap.set(item, data).pipe(
            map(() => true),
            catchError((err) => of(err))
        );
    }

    /** Remove data from local storage */
    public remove(item: string): Observable<boolean> {
        return this.storageMap.delete(item).pipe(
            map(() => true),
            catchError((err) => of(err))
        );
    }

    /** Clear all data from local storage */
    public clearAll(): Observable<boolean> {
        return this.storageMap.clear().pipe(
            map(() => true),
            catchError((err) => of(err))
        );
    }
}
